var map = {
	"./aak.jpg": "f5b3",
	"./bulkiin.jpg": "5fa6",
	"./chak-pakaal.jpg": "34de",
	"./chukwa.jpg": "8b14",
	"./kiin.jpg": "f374",
	"./old/aak.png": "3780",
	"./old/bulk.png": "d4da",
	"./old/chakpakaal.png": "a9aa",
	"./old/chukwa.png": "5000",
	"./old/kiin.png": "9550",
	"./old/piik.png": "0e0e",
	"./old/zacknite.png": "c9b4",
	"./piikill.jpg": "8cd6",
	"./zacknite.jpg": "ba40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8628";